import { __decorate } from 'tslib';
import { Pipe, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
let USPhoneNumberPipe = class USPhoneNumberPipe {
    transform(value) {
        if (value) {
            const valueString = value + '';
            if (valueString.length === 7)
                return `${valueString.slice(0, 3)}-${valueString.slice(3)}`;
            else if (valueString.length === 10)
                return `(${valueString.slice(0, 3)}) ${valueString.slice(3, 6)}-${valueString.slice(6)}`;
            else
                return valueString;
        }
        else
            return value;
    }
};
USPhoneNumberPipe.ɵfac = function USPhoneNumberPipe_Factory(t) { return new (t || USPhoneNumberPipe)(); };
USPhoneNumberPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "USPhone", type: USPhoneNumberPipe, pure: true });

let USPhoneModule = class USPhoneModule {
};
USPhoneModule.ɵfac = function USPhoneModule_Factory(t) { return new (t || USPhoneModule)(); };
USPhoneModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: USPhoneModule });
USPhoneModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(USPhoneNumberPipe, [{
        type: Pipe,
        args: [{
                name: 'USPhone'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(USPhoneModule, [{
        type: NgModule,
        args: [{
                declarations: [USPhoneNumberPipe],
                exports: [USPhoneNumberPipe]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(USPhoneModule, { declarations: [USPhoneNumberPipe], exports: [USPhoneNumberPipe] }); })();

/*
 * Public API Surface of angular-usphone
 */

/**
 * Generated bundle index. Do not edit.
 */

export { USPhoneModule, USPhoneNumberPipe as ɵa };

